module.exports = __webpack_public_path__ + "img/ZVE10LW.c5d76f7a.jpg";